$(document).ready(function(){

	$("#FeaturedImageZoom-product-template-28190904221814, #FeaturedImage-product-template-28190904221814").click(function(){
		$(".freshwater-video-popup").show();
	});
	$(".freshwater-video-popup-close").click(function () {
		$(".freshwater-video-popup").hide();
		$(".freshwater-video-popup iframe").each(function(index) {
	        $(this).attr('src', $(this).attr('src'));

	        // return false;
      	});
	});	

});
